export default __webpack_public_path__ + "static/media/Group1080.1089d3e2.svg";